module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Copy Order","numberToCopy":"Copies to Create","plannedETD":"Planned Departure","selectDate":"Select date","copyOrder":"Copy"},"no":{"title":"Kopier oppdrag","numberToCopy":"Antall Oppdrag","plannedETD":"Planlagt Avgang","selectDate":"Velg dato","copyOrder":"Kopier"}}')
  delete Component.options._Ctor
}
